export default __webpack_public_path__ + "media/alex.82f8561c.jpg";